import { getYear, subYears } from 'date-fns';
import { range } from 'lodash';

export function formattedDateOptions(max) {
  return Array(max)
    .fill()
    .map((_, i) => (
      <option
        key={i + 1} // eslint-disable-line react/no-array-index-key
        value={i + 1}
      >
        {`${i + 1}`.padStart(2, '0')}
      </option>
    ));
}

export function formattedYearOptions() {
  const startYear = getYear(subYears(new Date(), 120));
  const endYear = getYear(new Date());

  return range(startYear, endYear + 1)
    .reverse()
    .map((num) => (
      <option
        key={num} // eslint-disable-line react/no-array-index-key
        value={num}
      >
        {num}
      </option>
    ));
}
